import React from "react";
import { AnimatePresence, motion } from "framer-motion";

const PageWrapper = ({ children }) => {
  return (
    <AnimatePresence>
      <motion.div
        style={{ width: "100%" }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25 }}
        className="w-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageWrapper;
